var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "wh100" },
    [
      _c(
        "el-menu",
        {
          staticClass: "el-menu-vertical-demo",
          staticStyle: { height: "100%" },
          attrs: {
            "default-active": _vm.activeIndex,
            collapse: _vm.isCollapse,
          },
          on: { select: _vm.handleSelect },
        },
        _vm._l(_vm.menuData, function (item) {
          return _c("menu-item", {
            key: item[_vm.fieldMap.id],
            attrs: {
              item: item,
              picon: _vm.picon,
              cicon: _vm.cicon,
              "field-map": _vm.fieldMap,
            },
            on: { click: _vm.handleClick },
          })
        }),
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }